export interface UmpireVideo {
  id?: string;
  type: 'video';
  external_url: string;
  author: string;
  filename: string;
  description: string;
}
